import * as React from 'react';
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={11.413}
    data-name="Email 15"
    {...props}>
    <g fill="#0cd550" data-name="Group 8153">
      <path
        d="M8.358 6.204a1.915 1.915 0 0 1-1.716 0L.376 3.048v7.375a.989.989 0 0 0 .989.988h12.271a.988.988 0 0 0 .988-.988V3.048Z"
        data-name="Path 10243"
      />
      <path
        d="m8.033 5.645 6.169-3.108a1.45 1.45 0 0 0 .8-1.295v-.2A1.04 1.04 0 0 0 13.96 0H1.04A1.041 1.041 0 0 0 0 1.04v.2a1.45 1.45 0 0 0 .8 1.295l6.169 3.108a1.187 1.187 0 0 0 1.066 0"
        data-name="Path 10244"
      />
    </g>
    <path
      fill="#00c744"
      d="M13.635 11.413H8.876L4.99 5.372l1.653.829a1.909 1.909 0 0 0 1.715 0l6.267-3.152v7.377a.989.989 0 0 1-.99.987ZM7.501 5.771a1.186 1.186 0 0 1-.533-.126L4.301 4.301 1.535.001H13.96A1.041 1.041 0 0 1 15 1.04v.2a1.44 1.44 0 0 1-.8 1.294L8.035 5.645a1.186 1.186 0 0 1-.534.126Z"
      data-name="Path 10436"
    />
  </svg>
);
export default SvgComponent;
